import { createSelector } from '@ngrx/store';

import { selectFehStandaloneFormsState } from '../feh-standalone-forms.state';
import { generalAdviceFormSelectorKey } from '../reducers';

export const selectGeneralAdviceFormState = createSelector(
  selectFehStandaloneFormsState,
  (state) => state[generalAdviceFormSelectorKey]
);

export const selectGeneralAdviceSubmitState = createSelector(
  selectGeneralAdviceFormState,
  (state) => state.submitState
);

export const selectGeneralAdviceRedirectUrl = createSelector(
  selectGeneralAdviceFormState,
  (state) => state.redirectUrl
);
